import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, onAuthStateChanged, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../firebase";

import InputControl from "../InputControl/InputControl";
import styles from "./Login.module.css";

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [values, setValues] = useState({
    email: "",
    pass: "",
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);

  // Check the user's authentication status on component mount
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // If the user is already logged in, redirect to the next page
        navigate("../Vehicletype");
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  const handleSubmission = () => {
    setLoading(true);
    if (!values.email || !values.pass) {
      setErrorMsg("Fill all fields");
      return;
    }
    setErrorMsg("");

    setSubmitButtonDisabled(true);
    signInWithEmailAndPassword(auth, values.email, values.pass)
      .then(async (res) => {
        setSubmitButtonDisabled(false);

        navigate("../Vehicletype");
      })
      .catch((err) => {
        setSubmitButtonDisabled(false);
        setErrorMsg(err.message);
      });
  };

  const handleGoogleSignIn = async () => {
    try {
      setLoading1(true);
      const provider = new GoogleAuthProvider();
      const res = await signInWithPopup(auth, provider);
      const user = res.user;
      navigate("../Vehicletype");
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  const handleForgotPassword = () => {
    navigate("/forgotpass");
  };
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  return (
    <div className={styles.container}>
      <div className={styles.innerBox}>
        <h1 className={styles.heading}>Login</h1>

        <input
              type="email"
              placeholder="&#xf0e0; Enter email address"
              value={values.email}
              onChange={(event) => setValues((prev) => ({ ...prev, email: event.target.value }))}
              style={{
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "100%",
                fontFamily: "Arial, FontAwesome", // Ensure FontAwesome is used for the icon
              }}
            />
          <div style={{ position: "relative" }}>
       <input
              type={showPassword ? "text" : "password"}
              placeholder="&#xf13e; Enter password"
              value={values.pass}
              onChange={(event) => setValues((prev) => ({ ...prev, pass: event.target.value }))}
              style={{
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "100%",
                fontFamily: "Arial, FontAwesome", // Ensure FontAwesome is used for the icon
              }}
            />
        <button
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
            style={{
              width: "40px",
              height: "100%",
              border: "none",
              backgroundColor: "transparent",
              position: "absolute",
              right: "0",
              top: "0",
              color:"#000",
              cursor: "pointer",
            }}
          >
            {showPassword ? "Hide" : "Show"}
          </button>

          </div>
        <div className={styles.button}>
          <b className={styles.error}>{errorMsg}</b>
          <button disabled={submitButtonDisabled} onClick={handleSubmission}
              >
                {loading ? "Loging in..." : "Login"}
          </button>
          <button onClick={handleForgotPassword}>
            Forgot Password
          </button>
          <p style={{ textAlign: "center", marginTop: "10px" }}>or</p>
              <button
                style={{ width: "100%", padding: "10px", marginBottom: "10px", backgroundColor: "#fff", color: "#000", border: "none", borderRadius: "5px", cursor: "pointer" }}
                onClick={handleGoogleSignIn}
                disabled={loading1}
              >
                <img src="https://image.similarpng.com/very-thumbnail/2020/12/Illustration-of-Google-icon-on-transparent-background-PNG.png" alt="Google Icon" style={{ marginRight: "10px", width: "20px", height: "20px" }} />
                {loading1 ? "Loging in with Google..." : "Login with Google"}
              </button>
          <p>
            Don't have an account?{" "}
            <span>
              <Link to="/signup">Sign up</Link>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
